import React, { useState, useEffect } from 'react';
import API from '../utils/api';

export default function AdminSettings() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    API.get('/settings')
      .then(r => { if (r.data.success) setForm(r.data.data); })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setMsg('');
    try {
      // logoUrl is intentionally excluded from updates
      const { logoUrl, ...rest } = form;
      const r = await API.patch('/settings', rest);
      if (r.data.success) setMsg('✅ Settings saved!');
    } catch { setMsg('❌ Save failed.'); }
    finally { setSaving(false); }
  };

  const f = (key, label, type = 'text', placeholder = '') => (
    <div className="admin-fg">
      <label className="admin-fl">{label}</label>
      <input
        type={type} className="admin-fi"
        value={form[key] || ''} placeholder={placeholder}
        onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
      />
    </div>
  );

  if (loading) return <div className="admin-loading">Loading settings…</div>;

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <h2 className="admin-page__title">Site Settings</h2>
      </div>

      {msg && (
        <div className={`admin-alert ${msg.startsWith('✅') ? 'admin-alert--ok' : 'admin-alert--err'}`} style={{ marginBottom: 20 }}>
          {msg}
        </div>
      )}

      <form onSubmit={handleSave} className="admin-card">
        <h3 className="admin-card__title">📋 Site Information</h3>
        <div className="admin-form">
          {f('siteName', 'Site Name', 'text', "ANN'S Beauty Parlour")}
          {f('tagline', 'Tagline', 'text', 'Where Elegance Meets Perfection')}
          {f('phone', 'Primary Phone', 'text', '+91 98765 43210')}
          {f('phone2', 'Second Phone (optional)', 'text', '+91 XXXXX XXXXX')}
          {f('email', 'Email', 'email', 'hello@annsbeauty.in')}
          {f('address', 'Address', 'text', 'Tirunelveli, Tamil Nadu')}
          {f('workingHours', 'Working Hours', 'text', 'Mon–Sat: 9 AM – 8 PM | Sun: 10 AM – 6 PM')}
          {f('instagram', 'Instagram URL', 'url', 'https://www.instagram.com/_anns_beauty_parlour...')}
          {f('whatsapp', 'WhatsApp Number (digits only)', 'text', '917904082095')}
          {f('mapsUrl', 'Google Maps URL', 'url', 'https://maps.google.com/?q=...')}
          <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save Settings'}
          </button>
        </div>
      </form>

      <ChangePassword />
    </div>
  );
}

function ChangePassword() {
  const [form, setForm] = useState({ current: '', newPassword: '' });
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword.length < 6) { setMsg('❌ Password must be at least 6 characters'); return; }
    setSaving(true); setMsg('');
    try {
      const r = await API.patch('/auth/password', form);
      if (r.data.success) { setMsg('✅ Password changed!'); setForm({ current: '', newPassword: '' }); }
    } catch (err) {
      setMsg(`❌ ${err.response?.data?.message || 'Failed'}`);
    } finally { setSaving(false); }
  };

  return (
    <div className="admin-card" style={{ marginTop: 24 }}>
      <h3 className="admin-card__title">🔒 Change Password</h3>
      {msg && <div className={`admin-alert ${msg.startsWith('✅') ? 'admin-alert--ok' : 'admin-alert--err'}`} style={{ marginBottom: 16 }}>{msg}</div>}
      <form onSubmit={handleSubmit} className="admin-form">
        <div className="admin-fg">
          <label className="admin-fl">Current Password</label>
          <input type="password" className="admin-fi" value={form.current} onChange={e => setForm(f => ({ ...f, current: e.target.value }))} required />
        </div>
        <div className="admin-fg">
          <label className="admin-fl">New Password</label>
          <input type="password" className="admin-fi" value={form.newPassword} onChange={e => setForm(f => ({ ...f, newPassword: e.target.value }))} required />
        </div>
        <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>{saving ? 'Saving…' : 'Change Password'}</button>
      </form>
    </div>
  );
}
